const SOCIAL_NETWORKING_LINKS_PREFIX = "SocialNetworkLinks";

export const SOCIAL_NETWORKING_LINKS_CLASSES = {
  link: `${SOCIAL_NETWORKING_LINKS_PREFIX}-link`,
  iconWrap: `${SOCIAL_NETWORKING_LINKS_PREFIX}-iconWrap`,
  iconItem: `${SOCIAL_NETWORKING_LINKS_PREFIX}-iconItem`,
  list: `${SOCIAL_NETWORKING_LINKS_PREFIX}-list`,
};
